export enum CommentType {
  Files = 1,
  RoutePoint = 2,
  Route = 3,
  Markdown = 4,
}
